import { apiClient } from '@/shared/api';
import { handleRequest } from '@/shared/api/apiWrapper.ts';

export async function getOperationDetails<T>(operationId: string): Promise<T> {
  const request = () => apiClient.get(`/operations/details/${operationId}`);
  const response = await handleRequest(request);

  return response.data;
}

export async function getOperationDetailsPdf<T>(
  operationId: string
): Promise<T> {
  const request = () =>
    apiClient.get(`/operations/details/${operationId}/pdf`, {
      responseType: 'blob',
    });
  const response = await handleRequest(request);

  return response.data;
}

export async function cancelOperation(operationId: string): Promise<void> {
  const request = () => apiClient.delete(`/operations/cancel/${operationId}`);
  const response = await handleRequest(request);
  return response.data;
}
